import React from "react";
import ChatMessage, {
  ChatContainer,
} from "../../../../ui-kit/ChatMessage/ChatMessage";
import { Typography } from "../../../../ui-kit/Typography";
import Gutter from "../../../../ui-kit/Gutter";
import { useWebTranslation } from "../../../../translations";
import { StepProps } from "../types";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { updateAnimalById } from "components/Signup/store/slices/animals";

const AnimalSex = ({ next, transitioning }: StepProps) => {
  const { t } = useWebTranslation();

  const { name, species, sex, id } = useCurrentAnimal();
  const dispatch = useSignupDispatch();

  return (
    <ChatContainer leaving={transitioning}>
      <ChatMessage>
        <Typography>
          {t("signup.animal_sex.text", {
            name: name ?? "",
            species: species ?? "",
          })}
        </Typography>
      </ChatMessage>
      <Gutter size={2} />
      <ChatMessage
        fromMe
        blink
        onPress={async () => {
          dispatch(updateAnimalById({ id, update: { sex: "female" } }));
          next();
        }}
        active={sex === "female"}
      >
        <Typography>
          {t("{{species, animal_pronoun(sex: female)}}", {
            species: species ?? "",
          })}
        </Typography>
      </ChatMessage>
      <ChatMessage
        fromMe
        blink
        onPress={() => {
          dispatch(updateAnimalById({ id, update: { sex: "male" } }));
          next();
        }}
        active={sex === "male"}
      >
        <Typography>
          {t("{{species, animal_pronoun(sex: male)}}", {
            species: species ?? "",
          })}
        </Typography>
      </ChatMessage>
    </ChatContainer>
  );
};

export default AnimalSex;
